import { derived, writable } from "svelte/store";
import { utils } from "../src/services/Utils";
class StationStore {
    constructor(stationName = writable(''), showPlayer = writable(false), allStations = writable({}), trackList = writable([]), schedule = writable([]), liveContent = writable([]), playingDate = writable(''), playPause = writable(false), playerDuration = writable()) {
        this.stationName = stationName;
        this.showPlayer = showPlayer;
        this.allStations = allStations;
        this.trackList = trackList;
        this.schedule = schedule;
        this.liveContent = liveContent;
        this.playingDate = playingDate;
        this.playPause = playPause;
        this.playerDuration = playerDuration;
    }
    get getAllStations() {
        // Use derived to access writable values and export as readonly
        return derived([this.allStations], ([$allStations]) => {
            return $allStations;
        });
    }
    get getSelectedStation() {
        return derived([this.allStations, this.stationName], ([$allStations, $stationName]) => {
            if ($stationName) {
                /*try {
                    if ($allStations[$stationName]['ekipa']['voditelj_ime'] === '#N/A') {
                        $allStations[$stationName]['ekipa']['voditelj_ime'] = false
                    }
                    if (utils.validateURL($allStations[$stationName]['ekipa']['voditelj_slika_url']) === false) {
                        $allStations[$stationName]['ekipa']['voditelj_slika_url'] = false
                    }
                } catch (error) {
                    $allStations[$stationName]['ekipa']['voditelj_ime'] = false
                    $allStations[$stationName]['ekipa']['voditelj_slika_url'] = false
                }*/
                //if ($allStations[$stationName][])
                return $allStations[$stationName];
            }
        });
    }
    get useCase() {
        return derived([this.allStations, this.stationName], ([$allStations, $stationName]) => {
            let sklon = {
                voditelj: '',
                napovedovalec: '',
                urednik: ''
            };
            if ($stationName && $allStations) {
                if ($allStations[$stationName].ekipa.glasbenik_spol === 'M') {
                    sklon.urednik = 'Glasbeni urednik';
                }
                else {
                    sklon.urednik = 'Glasbena urednica';
                }
                if ($allStations[$stationName].ekipa.napovedovalec_spol === 'M') {
                    sklon.napovedovalec = 'Napovedovalec';
                }
                else {
                    sklon.napovedovalec = 'Napovedovalka';
                }
                if ($allStations[$stationName].ekipa.voditelj_spol === 'M') {
                    sklon.voditelj = 'Voditelj';
                }
                else {
                    sklon.voditelj = 'Voditeljica';
                }
                return sklon;
            }
        });
    }
    get returnLastThreeSongs() {
        return derived([this.trackList], ([$trackList]) => {
            if ($trackList) {
                let tempArray = $trackList.slice(-6);
                tempArray = tempArray.map((e, i) => tempArray[tempArray.length - i - 1]);
                return tempArray;
            }
        });
    }
    /*   get returnShowDuration() {
           return derived(
               [this.allStations, this.stationName],
               ([$allStations, $stationName]) => {
                   if ($allStations && $stationName) {
                       if ($allStations[$stationName].onair.current && $allStations[$stationName].onair.meta && $allStations[$stationName].onair.next) {
                           let start = $allStations[$stationName].onair.current.ura ?? "00:00"
                           let time = $allStations[$stationName].onair.meta.time ?? "00:00"
                           let next = $allStations[$stationName].onair.next.ura ?? "00:00"
                           let percent = utils.durationProcent(start, time, next)
                           let radius = 52
                           let circumference = radius * 2 * Math.PI;
                           return circumference - percent / 100 * circumference;
                       }
                       else {
                           let start = "00:00"
                           let time = "00:00"
                           let next = "00:00"
                           let percent = utils.durationProcent(start, time, next)
                           let radius = 52
                           let circumference = radius * 2 * Math.PI;
                           return circumference - percent / 100 * circumference;
                       }
                   }
               }
           )
       }*/
    get showStartAndEnd() {
        let shows = {
            currentShowStart: '',
            currentShowEnd: '',
            nextShowStart: '',
            nextShowEnd: ''
        };
        return derived([this.allStations, this.stationName], ([$allStations, $stationName]) => {
            if ($stationName) {
                let station = $allStations[$stationName];
                if (station.onair) {
                    return shows = {
                        currentShowStart: utils.convert(station.onair.current.billedstart),
                        currentShowEnd: utils.convert(station.onair.current.billedend),
                        nextShowStart: utils.convert(station.onair.next.billedstart),
                        nextShowEnd: utils.convert(station.onair.next.billedend)
                    };
                }
            }
        });
    }
    get getLiveStationNames() {
        return derived([this.allStations, this.stationName], ([$allStations, $stationName]) => {
            if ($stationName) {
                switch ($allStations[$stationName].ekipa.kanal) {
                    case 'ra1':
                        return 'ra.a1';
                    case 'val202':
                        return 'ra.val202';
                    case 'ars':
                        return 'ra.ars';
                    case 'rakp':
                        return 'ra.kp';
                    case 'capo':
                        return 'ra.capo';
                    default:
                        break;
                }
            }
        });
    }
    get getSosPageNames() {
        return derived([this.allStations, this.stationName], ([$allStations, $stationName]) => {
            if ($stationName) {
                switch ($allStations[$stationName].ekipa.kanal) {
                    case 'ra1':
                        return 'https://radioprvi.rtvslo.si/sos/';
                    case 'val202':
                        return 'https://val202.rtvslo.si/sos/';
                    case 'ars':
                        return 'https://ars.rtvslo.si/sos/';
                    default:
                        break;
                }
            }
        });
    }
    get getShowBeginning() {
        return derived([this.allStations, this.stationName, this.playerDuration], ([$allStations, $stationName, $playerDuration]) => {
            if ($stationName) {
                const station = $allStations[$stationName];
                let stationPlayingData = {
                    //playerDuration: $playerDuration,
                    start: station.onair.current.billedstart,
                    currentTime: station.onair.meta.time
                };
                return utils.calculateBeginning(stationPlayingData);
            }
        });
    }
    get getCurrentTimeFromAPI() {
        return derived([this.allStations, this.stationName], ([$allStations, $stationName]) => {
            if ($stationName) {
                const station = $allStations[$stationName];
                return utils.HMStoSec1(station.onair.meta.time);
            }
        });
    }
    get getCurrentTimeFromBrowser() {
        return derived([this.allStations], ([$allStations]) => {
            let today = new Date();
            today.toLocaleString("sl-SL", { timeZone: "Europe/Ljubljana" });
            let time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
            const currentTime = utils.HMStoSec1(time);
            return currentTime;
        });
    }
}
// Export a singleton
export const stationStore = new StationStore();
